<template>
  <section class="news-center-content" aria-label="新闻列表">
    <aside class="news-center-sidebar">
      <p>分类</p>
      <div class="news-center-filters" role="tablist" aria-label="新闻分类">
        <button
          v-for="category in categories"
          :key="category.key"
          :class="{ selected: activeCategory === category.key }"
          :aria-selected="activeCategory === category.key"
          type="button"
          role="tab"
          @click="activeCategory = category.key"
        >{{ category.name }}</button>
      </div>
    </aside>

    <div class="news-center-list" role="tabpanel">
      <div class="news-center-list-heading"><h2>{{ activeCategoryName }}</h2><span>{{ paddedCount }} 篇资讯</span></div>
      <a v-for="item in visibleNews" :key="item.key" :href="getNewsHref(item)" :target="opensInNewTab(item) ? '_blank' : null" :rel="opensInNewTab(item) ? 'noopener noreferrer' : null" class="news-center-item">
        <div class="news-center-item-copy">
          <h2>{{ item.title }}</h2>
          <p v-if="getExcerpt(item)">{{ getExcerpt(item) }}</p>
          <div class="news-center-meta"><span>{{ item.category }}</span><time>{{ formatDate(item.publishTime) }}</time></div>
        </div>
        <div :class="['news-center-image', { 'news-center-image-empty': !item.coverImg }]">
          <img v-if="item.coverImg" :src="item.coverImg" :alt="item.title" @error="removeBrokenCover(item)" />
          <span aria-hidden="true">↗</span>
        </div>
      </a>
    </div>
  </section>
</template>

<script>
/* global _api */
// import LocalNews from "./local_news";

const displayedCategoryIds = [5, 6, 7, 2];
const fallbackCategories = [
  { key: "all", name: "全部" },
  { key: "5", name: "战略观察" },
  { key: "6", name: "商户服务" },
  { key: "7", name: "公益助农" },
  { key: "2", name: "公司动态" }
];

export default {
  name: "NewsCenter",
  data() {
    return { categories: fallbackCategories, activeCategory: "all", allNews: [], groupedNews: this.emptyGroupedNews() };
  },
  computed: {
    activeCategoryName() {
      const category = this.categories.find(item => item.key === this.activeCategory);
      return category ? category.name : "全部";
    },
    visibleNews() {
      if (this.activeCategory === "all") {
        return this.allNews;
      }
      return this.groupedNews[this.activeCategory] || [];
    },
    paddedCount() { return String(this.visibleNews.length).padStart(2, "0"); }
  },
  created() {
    // this.groupedNews = this.buildLocalNews(LocalNews);
    this.requestNewsTags();
    this.requestNewsList();
  },
  methods: {
    emptyGroupedNews() {
      return displayedCategoryIds.reduce((result, id) => {
        result[id] = [];
        return result;
      }, {});
    },
    buildNews(source) {
      const result = this.emptyGroupedNews();
      Object.keys(result).forEach(key => {
        const items = source[key] && source[key].items ? source[key].items : [];
        result[key] = items.map((item, index) => this.normalizeNews(item, key, index));
      });
      return result;
    },
    requestNewsTags() {
      _api.all.getNewsTags().then(res => {
        const tags = Array.isArray(res) ? res : res && res.data;
        if (!Array.isArray(tags)) return;
        this.categories = [{ key: "all", name: "全部" }].concat(
          displayedCategoryIds.map(id => {
            const tag = tags.find(item => Number(item.id) === id);
            return { key: String(id), name: tag ? tag.tag : "" };
          }).filter(item => item.name)
        );
      }).catch(() => {});
    },
    normalizeNews(item, categoryKey, index) {
      const category = this.categories.find(value => value.key === String(categoryKey));
      return Object.assign({}, item, {
        category: category ? category.name : "美菜动态",
        coverImg: item.coverImg || item.coverImage || item.imageUrl || item.image || "",
        key: String(categoryKey) + "-" + (item.id || item.title || index),
        publishTime: item.publishTime || ""
      });
    },
    getExcerpt(item) {
      const text = (item.summary || item.content || "").replace(/<.+?>/g, "").replace(/&nbsp;/g, "").trim();
      return text;
    },
    getNewsHref(item) {
      if (Number(item.jumpExternal) === 1 && item.hyperUrl) return item.hyperUrl;
      if (item.externalUrl) return item.externalUrl;
      return item.id ? "/news/detail/" + item.id : "#";
    },
    opensInNewTab(item) {
      return (Number(item.jumpExternal) === 1 && !!item.hyperUrl) || !!item.externalUrl;
    },
    removeBrokenCover(item) {
      this.$set(item, "coverImg", "");
    },
    formatDate(value) {
      if (!value) return "";
      if (typeof value === "string" && value.indexOf(".") !== -1) return value;
      const date = new Date(value);
      return isNaN(date.getTime()) ? "" : date.getFullYear() + "-" + String(date.getMonth() + 1).padStart(2, "0") + "-" + String(date.getDate()).padStart(2, "0");
    },
    requestNewsList() {
      _api.all.getNewsList({ pageSize: 12, pageNumber: 1, tag: "" }).then(res => {
        if (!res || !res.data) return;
        const payload = res.data;
        const allItems = payload.all && Array.isArray(payload.all.items) ? payload.all.items : [];
        this.allNews = allItems.map((item, index) => this.normalizeNews(item, item.tag, index));
        this.groupedNews = this.buildNews(payload.byTag || {});
      }).catch(() => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.news-center-content,.news-center-content *,.news-center-content *::before,.news-center-content *::after { box-sizing:border-box; }.news-center-content { display:grid;max-width:1180px;margin:0 auto;padding:58px 0 96px;align-items:start;gap:clamp(52px,7vw,100px);grid-template-columns:178px minmax(0,1fr);background:#fff; }.news-center-sidebar { position:sticky;top:112px; }.news-center-sidebar > p { margin:0 0 14px;color:#263129;font-size:14px;font-weight:600; }.news-center-filters { display:flex;flex-direction:column;gap:9px; }.news-center-filters button { position:relative;padding:12px 16px;border:0;border-radius:5px;background:#f5f6f4;color:#4f5952;cursor:pointer;font:inherit;font-size:14px;text-align:left;transition:background .2s ease,color .2s ease,padding .2s ease; }.news-center-filters button::before { position:absolute;top:50%;left:0;width:3px;height:0;transform:translateY(-50%);border-radius:99px;background:#68ad25;content:"";transition:height .2s ease; }.news-center-filters button:hover { background:#eef4e9;color:#173f24; }.news-center-filters button.selected { padding-left:24px;background:#eaf4df;color:#173f24;font-weight:600; }.news-center-filters button.selected::before { height:22px; }
.news-center-list { min-width:0; }.news-center-list-heading { display:flex;padding-bottom:20px;align-items:baseline;justify-content:space-between;border-bottom:1px solid #dfe4df; }.news-center-list-heading h2 { margin:0;color:#182019;font-size:28px;font-weight:550;letter-spacing:-.03em;line-height:1.5; }.news-center-list-heading span { color:#9aa19c;font-size:11px;letter-spacing:.1em; }.news-center-item { display:grid;padding:30px 0;align-items:stretch;gap:clamp(28px,4vw,66px);grid-template-columns:minmax(0,1fr) 210px;border-bottom:1px solid #e5e8e5;color:inherit;text-decoration:none; }.news-center-item-copy { display:flex;min-width:0;padding:5px 0 3px;flex-direction:column; }.news-center-item h3 { margin:0 0 12px;color:#182019;font-size:clamp(19px,1.75vw,24px);font-weight:550;letter-spacing:-.025em;line-height:1.45;transition:color .2s ease; }.news-center-item:hover h3 { color:#68ad25; }.news-center-item-copy > p { display:-webkit-box;overflow:hidden;margin:0 0 22px;color:#747d76;font-size:13px;line-height:1.75;-webkit-box-orient:vertical;-webkit-line-clamp:2; }.news-center-meta { display:flex;margin-top:auto;align-items:center;gap:18px; }.news-center-meta span { padding:4px 9px;border:1px solid rgba(104,173,37,.38);border-radius:3px;color:#68ad25;font-size:11px; }.news-center-meta time { color:#a1a8a3;font-size:12px; }.news-center-image { position:relative;min-height:138px;align-self:start;aspect-ratio:210 / 146.5;overflow:hidden;border-radius:7px;background:#eef2ec; }.news-center-image::after { position:absolute;inset:0;background:linear-gradient(180deg,transparent 55%,rgba(7,36,20,.25));content:""; }.news-center-image-empty::before { position:absolute;inset:0;background:linear-gradient(135deg,#f3f6f1,#e4ebdf);content:""; }.news-center-image img { display:block;width:100%;height:100%;object-fit:cover;transition:transform .4s ease; }.news-center-item:hover .news-center-image img { transform:scale(1.045); }.news-center-image span { position:absolute;right:10px;bottom:10px;z-index:1;display:flex;width:30px;height:30px;align-items:center;justify-content:center;border-radius:50%;background:rgba(255,255,255,.92);color:#173f24;font-size:13px; }
@media (max-width:1228px) { .news-center-content { margin-right:24px;margin-left:24px; } }
@media (max-width:800px) { .news-center-content { padding-top:32px;grid-template-columns:1fr;gap:28px; }.news-center-sidebar { position:sticky;top:62px;z-index:5;background:#fff; }.news-center-sidebar > p { display:none; }.news-center-filters { overflow-x:auto;padding:8px 0 12px;flex-direction:row;gap:8px;scrollbar-width:none; }.news-center-filters::-webkit-scrollbar { display:none; }.news-center-filters button { padding:10px 16px;flex:0 0 auto;text-align:center; }.news-center-filters button.selected { padding-left:16px; }.news-center-filters button::before { display:none; } }
@media (max-width:560px) { .news-center-content { margin-right:18px;margin-left:18px;padding-bottom:68px; }.news-center-item { padding:23px 0;gap:20px;grid-template-columns:1fr 112px; }.news-center-item h3 { margin-bottom:9px;font-size:17px; }.news-center-item-copy > p { display:none; }.news-center-image { min-width:0;min-height:0;aspect-ratio:112 / 88; }.news-center-image span { display:none; }.news-center-meta { gap:10px; }.news-center-meta time { font-size:10px; } }

@media (min-width:801px) {
  .news-center-content { display:flex;max-width:1280px;margin:0 auto;padding:32px 20px 100px;gap:80px; }
  .news-center-sidebar { top:100px;flex:0 0 148px; }
  .news-center-sidebar > p { margin-bottom:14px; }
  .news-center-filters { gap:10px; }
  .news-center-filters button { width:148px;height:38px;padding:0 12px;border-radius:6px;font-size:14px;text-align:center; }
  .news-center-filters button.selected { padding-left:12px; }
  .news-center-list { flex:1;min-width:0; }
  .news-center-list-heading { display:none; }
  .news-center-item { display:flex;height:156px;margin-bottom:32px;padding:0;gap:0;border:0; }
  .news-center-item-copy { display:flex;min-width:0;padding:0 40px 0 0;flex:1;justify-content:center; }
  .news-center-item h3 { margin:0 0 12px;color:#111925;font-size:20px;font-weight:500;letter-spacing:0;line-height:28px; }
  .news-center-item-copy > p { margin:0 0 14px;color:#777f8a;font-size:16px;line-height:24px;-webkit-line-clamp:1; }
  .news-center-meta { margin-top:0;gap:18px; }
  .news-center-meta span { padding:0 10px;border-color:rgba(104,173,37,.45);font-size:13px;line-height:22px; }
  .news-center-meta time { font-size:13px; }
  .news-center-image { width:208px;min-width:208px;min-height:156px;height:156px;aspect-ratio:auto;border-radius:16px; }
  .news-center-image::after,.news-center-image span { display:none; }
}

/* 与 Demo 新闻中心列表保持一致。 */
.news-center-item h2 { margin:0 0 12px;color:#182019;font-size:clamp(19px,1.75vw,24px);font-weight:550;letter-spacing:-.025em;line-height:1.45;transition:color .2s ease; }
.news-center-item:hover h2 { color:#68ad25; }
@media (min-width:801px) {
  .news-center-meta { gap:20px; }
  .news-center-item h2 { display:-webkit-box;overflow:hidden;margin:0 0 12px;color:#111925;font-size:20px;font-weight:500;letter-spacing:0;line-height:28px;-webkit-box-orient:vertical;-webkit-line-clamp:2; }
  .news-center-item:hover h2 { color:#568f20; }
}

@media (max-width:720px) {
  .news-center-content { display:block;max-width:none;margin:0;padding:0 0 60px;background:#fff; }
  .news-center-sidebar { position:sticky;top:62px;z-index:20;width:100%;height:54px;overflow:hidden;background:#fff; }
  .news-center-filters { height:54px;padding:8px 20px 12px;gap:8px;overflow-x:auto;flex-direction:row; }
  .news-center-filters button { height:34px;padding:0 14px;flex:0 0 auto;white-space:nowrap; }
  .news-center-list { margin:0;padding:12px 20px 0; }
  .news-center-list-heading { display:none; }
  .news-center-item { display:flex;height:98px;margin:0 0 16px;padding:0;gap:0;border:0; }
  .news-center-item-copy { padding:0 12px 0 0;flex:1;justify-content:center; }
  .news-center-item h2 { display:-webkit-box;overflow:hidden;margin:0 0 5px;color:#111925;font-size:16px;font-weight:500;line-height:22.4px;-webkit-box-orient:vertical;-webkit-line-clamp:2; }
  .news-center-item-copy > p { display:-webkit-box;margin:0 0 5px;font-size:13px;line-height:20px;-webkit-line-clamp:1; }
  .news-center-meta { margin:0;gap:12px; }
  .news-center-meta span { padding:0 5px;font-size:11px;line-height:20px; }
  .news-center-meta time { font-size:11px; }
  .news-center-image { width:130px;min-width:130px;height:98px;min-height:0;aspect-ratio:auto;border-radius:8px; }
  .news-center-image span { display:none; }
}
.news-center-filters button { font-family:"PingFang SC","Microsoft YaHei","Noto Sans CJK SC",Arial,sans-serif;font-size:14px;line-height:21px; }
.news-center-filters button.selected { background:#dff0c5;color:#173f24;font-weight:500; }
.news-center-item h2 { font-family:"PingFang SC","Microsoft YaHei","Noto Sans CJK SC",Arial,sans-serif; }
.news-center-sidebar > p { margin:0 0 8px;color:#111925;font-family:"PingFang SC","Microsoft YaHei","Noto Sans CJK SC",Arial,sans-serif;font-size:14px;font-weight:400;line-height:22px; }
@media (min-width:801px) { .news-center-filters button.selected::before { display:none; } }
</style>
